/*global window,console*/
/*eslint no-console:0*/
define('app/models/AnalyticsEntity',['require','glu/model','glu/http','app/store','glu/util','glu/$'],function(require) {
	'use strict';

	var Model = require('glu/model'),
		http = require('glu/http'),
		sessionStore = require('app/store'),
		_ = require('glu/util'),
		$ = require('glu/$');

	/**
	 * Base class for reports, segments and domains.  This way we can start to store common attributes in one central
	 * location.
	 */
	var AnalyticsEntity = Model.extend({

		http: http,

		getModelName: function() {
			return this.get('modelName');
		},

		getId: function() {
			return this.get('id');
		},

		setId: function(id) {
			return this.set('id', id);
		},

		getName: function() {
			return this.get('name');
		},

		setName: function(name) {
			return this.set('name', name);
		},

		getDescription: function() {
			return this.get('description');
		},

		setDescription: function(description) {
			return this.set('description', description);
		},

		getOwner: function() {
			return this.get('owner');
		},

		setOwner: function(owner) {
			return this.set('owner', owner);
		},

		isOwner: function() {
			return sessionStore.getApiUsername() === this.getOwner();
		},

		getIsPrivate: function() {
			return !!this.get('isPrivate');
		},

		setIsPrivate: function(isPrivate) {
			this.set('isPrivate', isPrivate);
		},

		getDateCreated: function() {
			return this.get('dateCreated');
		},

		getDateModified: function() {
			return this.get('dateModified');
		},

		canBeDeleted: function() {
			return this.isOwner();
		},

		getDomainId: function() {
			return this.get('domainId');
		},

		/**
		 * Determine if this entity is a widget.  In some cases we want to filter these out of results
		 * displayed to the end user.
		 *
		 * @returns {getWidgetType|boolean}
		 */
		isWidget: function() {
			return _.isFunction(this.getWidgetType) && this.getWidgetType();
		},

		/**
		 * Determine if this entity is an SPD report.  In some cases we want to filter these out of
		 * results displayed to the end user.
		 *
		 * @returns {getReportType|boolean}
		 */
		isSpdReport: function() {
			return this.getReportType && this.getReportType() === 'SPD';
		},

		/**
		 * Determine if the entity is configured as a chart.
		 *
		 * @returns {boolean}
		 */
		isChart: function() {
			return false;
		},

		serialize: function() {
			return this.toJSON();
		},

		delete: function() {
			return $.ajax(this.url(), {
				type: 'DELETE'
			});
		}
	});

	return AnalyticsEntity;
});

